export default __webpack_public_path__ + "x.svg";